import { Component, OnInit } from '@angular/core';
import { SideMenuComponent } from '../../core/components/side-menu/side-menu.component';
import { HeaderComponent } from '../../core/components/header/header.component';

import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { Menu } from '../../core/interface/menu';
import { ErrorListComponent } from '../../core/components/error-list/error-list.component';
import { StorageService } from '../../core/services/storage.service';
import { Location } from '../../core/interface/location';
import { APP_CONSTANTS } from '../../core/constants/app-constants';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  imports: [SideMenuComponent, HeaderComponent, RouterOutlet, ErrorListComponent],
})
export class DashboardComponent implements OnInit {
  public menu: Menu[] = [];
  public vendorMenu: Menu[] = [];

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.data.subscribe(({ menu, locations }) => {
      this.configureMenuItems(menu?.data, locations.data);
    });
  }

  configureMenuItems(data: any, locations: Location[]) {
    this.storageService.set('locations', locations);
    // Remove GLOB location
    const filteredLocations = locations.filter((loc) => loc.loc_code !== APP_CONSTANTS.GLOBAL_LOCATION_TYPE);
    const locationMenu: Menu[] = [];
    const locationVenderMenu: Menu[] = [];
    for (const loc of filteredLocations) {
      locationMenu.push({
        id: loc.loc_id,
        value: loc.location,
        route: loc.loc_code.toLowerCase(),
        child: data.inventory?.menu || [],
      });
      locationVenderMenu.push({
        id: loc.loc_id,
        value: loc.location,
        route: loc.loc_code.toLowerCase(),
        child: null,
      });
    }
    const menu: Menu = {
      id: 0,
      value: 'Inventory',
      child: locationMenu,
      route: 'inventory',
    };
    const vendorMenu: Menu = {
      id: 0,
      value: 'Vendor',
      child: locationVenderMenu,
      route: 'vendors',
    };
    this.menu.push(menu);
    this.vendorMenu.push(vendorMenu);
  }
}
